import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
// import css from './ProgressMeter.scss';
import { UserContext } from '../context/userContext';

const almostExpiredCount = 2; // After X count, we highlight/alert the user trial is ending

const ProgressMeter = ({
  numLeft,
  meterData,
  meterClick = () => {},
  ctaText
}) => {
  const { showScreen } = useContext(UserContext);
  if (isEmpty(meterData)) return null;

  const expiringSoon = numLeft <= almostExpiredCount;

  const expiringMessage = numViewsLeft => {
    if (numViewsLeft === 0) {
      return (
        <div>
          You’ve reached your monthly limit of articles.&nbsp;
          <span className="progress-meter__text--active" onClick={meterClick}>
            {ctaText}
          </span>
          <span
            className="progress-meter__text--active"
            onClick={e => {
              e.preventDefault();
              showScreen('login', 'modal');
            }}
          >
            Login
          </span>
          &nbsp;here.
        </div>
      );
    }

    return (
      <div>
        You have&nbsp;
        <span>
          {numViewsLeft} free {numViewsLeft === 1 ? 'article' : 'articles'}
        </span>
        &nbsp;left this month.&nbsp;
        <span className="progress-meter__text--active" onClick={meterClick}>
          {ctaText}
        </span>
        &nbsp;or&nbsp;
        <span
          className="progress-meter__text--active"
          onClick={e => {
            e.preventDefault();
            showScreen('login', 'modal');
          }}
        >
          Login
        </span>
        &nbsp;here.
      </div>
    );
  };

  return (
    <div className={`progress-meter ${expiringSoon ? 'css.highlight' : ''}`}>
      <div className="progress-meter__wrapper">
        <div className="progress-meter__text">{expiringMessage(numLeft)}</div>
      </div>
    </div>
  );
};

ProgressMeter.defaultProps = {
  numLeft: 6,
  meterData: {},
  meterClick: () => {},
  ctaText: ''
};

ProgressMeter.propTypes = {
  numLeft: PropTypes.number,
  meterData: PropTypes.arrayOf(PropTypes.shape({})),
  meterClick: PropTypes.func,
  ctaText: PropTypes.string
};

export default ProgressMeter;
